import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import VueApexCharts from 'vue-apexcharts';
export default /*#__PURE__*/_defineComponent({
  __name: 'Matrix',
  props: {
    series: {
      type: Array,
      default: function _default() {
        return [{
          name: 'risk',
          data: [[0, 0]]
        }];
      }
    },
    labelYAxis: {
      type: String,
      default: function _default() {
        return 'Magnitude';
      }
    },
    annotationY: {
      type: Number,
      default: function _default() {
        return 0;
      }
    },
    annotationX: {
      type: Number,
      default: function _default() {
        return 0;
      }
    },
    title: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    rangeYAxis: {
      type: Array,
      default: function _default() {
        return [1, 5];
      }
    }
  },
  setup: function setup(__props) {
    var _props$rangeYAxis$, _props$rangeYAxis, _props$rangeYAxis$2, _props$rangeYAxis2, _props$rangeYAxis$3, _props$rangeYAxis3;
    var props = __props;
    var chart = ref(null);
    var _useNuxtApp = useNuxtApp(),
      $i18n = _useNuxtApp.$i18n;
    var defaultOptions = {
      chart: {
        height: 650,
        type: 'scatter',
        zoom: {
          enabled: false
          // type: 'xy',
        }
      },
      title: {
        text: props.title,
        align: 'center',
        margin: 10,
        offsetX: 0,
        offsetY: 0,
        floating: false,
        style: {
          fontSize: '16px',
          fontWeight: 'bold',
          fontFamily: undefined,
          color: '#263238'
        }
      },
      animations: {
        enabled: false
      },
      style: {
        fontSize: '12px',
        fontFamily: undefined
      },
      background: 'rgba(255, 255, 255, 0.8)',
      borderColor: '#ccc',
      borderRadius: 5,
      grid: {
        show: true,
        row: {
          colors: ['#e5e5e5', 'transparent'],
          opacity: 0.5
        },
        column: {
          colors: ['#f8f8f8', 'transparent']
        },
        xaxis: {
          lines: {
            show: true
          }
        }
      },
      xaxis: {
        title: {
          text: $i18n.t('modules.csrd.likelihood'),
          style: {
            fontSize: '14px' // Customize the font size
          }
        },
        lines: {
          show: true
        },
        labels: {
          show: true,
          formatter: function formatter(val) {
            return parseFloat(val).toFixed(1); // this makes sure the x axis labels are rounded to 1 decimal place
          }
        },
        // tickAmount: 16,
        max: 5.0,
        min: 1.0
      },
      yaxis: {
        title: {
          text: props.labelYAxis,
          // The text label you want to display
          // offsetX: -20, // Adjust this value to move the label further to the left
          style: {
            fontSize: '14px' // Customize the font size
            // color: '#000', // Customize the text color
          }
        },
        lines: {
          show: true
        },
        labels: {
          show: true,
          formatter: function formatter(val) {
            return parseFloat(val).toFixed(1); // this makes sure the x axis labels are rounded to 1 decimal place
          }
        },
        tickAmount: 10,
        max: (_props$rangeYAxis$ = (_props$rangeYAxis = props.rangeYAxis) === null || _props$rangeYAxis === void 0 ? void 0 : _props$rangeYAxis[1]) !== null && _props$rangeYAxis$ !== void 0 ? _props$rangeYAxis$ : 5,
        min: (_props$rangeYAxis$2 = (_props$rangeYAxis2 = props.rangeYAxis) === null || _props$rangeYAxis2 === void 0 ? void 0 : _props$rangeYAxis2[0]) !== null && _props$rangeYAxis$2 !== void 0 ? _props$rangeYAxis$2 : 1
      },
      tooltip: {
        enabled: true,
        custom: function custom(_ref) {
          var _props$labelYAxis;
          var seriesIndex = _ref.seriesIndex,
            dataPointIndex = _ref.dataPointIndex,
            w = _ref.w;
          var series = w.config.series[seriesIndex];
          var data = series.data[dataPointIndex] || [];
          return "\n        <div class=\"custom-tooltip p-2\">\n          <span><strong>".concat(data[2] || '', "</strong></span>\n          <br/>\n          <span>").concat($i18n.t('modules.csrd.likelihood'), ": ").concat(data[0], "</span>\n          <br/>\n          <span>").concat((_props$labelYAxis = props.labelYAxis) !== null && _props$labelYAxis !== void 0 ? _props$labelYAxis : $i18n.t('modules.csrd.magnitude'), ": ").concat(data[1], "</span>\n        </div>\n      ");
        }
      },
      annotations: {
        yaxis: [{
          y: 3.0,
          y2: (_props$rangeYAxis$3 = (_props$rangeYAxis3 = props.rangeYAxis) === null || _props$rangeYAxis3 === void 0 ? void 0 : _props$rangeYAxis3[1]) !== null && _props$rangeYAxis$3 !== void 0 ? _props$rangeYAxis$3 : 5.0,
          borderColor: '#fff',
          fillColor: '#FEB019',
          label: {
            // text: 'Y-axis range',
          }
        }],
        xaxis: [{
          // normally it's likelihood
          x: 3.0,
          x2: 5.0,
          borderColor: '#fff',
          fillColor: '#FEB019',
          label: {
            // text: 'X-axis range',
          }
        }]
      }
    };
    watch([function () {
      return props.annotationY;
    }, function () {
      return props.annotationX;
    }], function () {
      var _props$rangeYAxis$4, _props$rangeYAxis4;
      var options = _objectSpread(_objectSpread({}, defaultOptions), {}, {
        annotations: {
          // we simply want to override annotations
          yaxis: [{
            y: props.annotationY,
            y2: (_props$rangeYAxis$4 = (_props$rangeYAxis4 = props.rangeYAxis) === null || _props$rangeYAxis4 === void 0 ? void 0 : _props$rangeYAxis4[1]) !== null && _props$rangeYAxis$4 !== void 0 ? _props$rangeYAxis$4 : 5.0,
            borderColor: '#fff',
            fillColor: '#FEB019',
            label: {
              // text: 'Y-axis range',
            }
          }],
          xaxis: [{
            x: props.annotationX,
            x2: 5.0,
            borderColor: '#fff',
            fillColor: '#FEB019',
            label: {
              // text: 'X-axis range',
            }
          }]
        }
      });
      chart.value.updateOptions(options);
    }
    // { deep: true },
    );
    return {
      __sfc: true,
      props: props,
      chart: chart,
      $i18n: $i18n,
      defaultOptions: defaultOptions,
      VueApexCharts: VueApexCharts
    };
  }
});